export enum RoleEnum {
	Specialist = 'specialist',
	Farmer = 'farmer',
	Individual = 'individual',
	Company = 'company',
}

export enum SpecialistType {
	Individual = 'individual',
	Company = 'consultingCompany',
}

export type Nullable<T> = T | null | undefined;

export interface Dictionary {
	id: string;
	name: string;
}
export interface SocialLink {
	facebook?: string;
	twitter?: string;
	instagram?: string;
	linkedin?: string;
}
